import AddIcon from "@mui/icons-material/Add"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import ContentPasteIcon from "@mui/icons-material/ContentPaste"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import PostAddIcon from "@mui/icons-material/PostAdd"
import Divider from "@mui/material/Divider"
import Grid from "@mui/material/Grid"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import React, { useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import {
	serviceQuestionDelete,
	serviceQuestionInsert,
	serviceQuestionMultiChoiceDelete,
	serviceQuestionMultiChoiceInsert,
	serviceQuestionMultiChoiceUpdate,
	serviceQuestionUpdate,
} from "../store/actions"
import { selectQuestionMultiChoicesByQuestionId } from "../store/reducers/serviceQuestionMultiChoiceReducer"
import {
	selectQuestionById,
	selectQuestionsByParentId,
	selectQuestionsByServiceId,
	selectQuestionsByServiceIdAndParentId,
} from "../store/reducers/serviceQuestionReducer"

const REQUIRED_TF = [
	{ value: "", label: "" },
	{ value: false, label: "Ei" },
	{ value: true, label: "Kyllä" },
]
const QUESTION_TYPE_TF = [
	{ value: "", label: "" },
	{ value: "multi", label: "Valintaruutu" },
	{
		value: "list",
		label: "Lista-valinta",
	},
	{ value: "one", label: "Radio-painike" },
	{ value: "text", label: "Teksti (yksirivi)" },
	{
		value: "title",
		label: "Otsikko",
	},
	{ value: "date", label: "Päivämäärä" },
	{ value: "multiline", label: "Teksti (monirivi)" },
]
const DATA_TYPE_TF = [
	{ value: "", label: "" },
	{ value: "int", label: "numero" },
	{
		value: "string",
		label: "tekstiä",
	},
	{ value: "boolean", label: "kyllä/ei" },
	{ value: "email", label: "email" },
	{ value: "phonenumber", label: "puhelinnumero" },
]

const RecursiveQuestionsAdmin = ({ parent, serviceId, questionId, setClipboard, clipboard, pasteQuestion }) => {
	const [expanded, setExpanded] = useState(false)
	const i = questionId
	const dispatch = useDispatch()

	const servicequestions = useSelector((state) => selectQuestionsByServiceId(state, serviceId), shallowEqual)
	const servicequestionsMemo = useMemo(() => servicequestions, [servicequestions])
	const servicequestion = useSelector((state) => selectQuestionById(state, questionId), shallowEqual)
	const servicequestionMemo = useMemo(() => {
		return servicequestion
	}, [servicequestion])
	const childquestions = useSelector((state) => selectQuestionsByParentId(state, questionId), shallowEqual)
	const childquestionsMemo = useMemo(() => {
		return childquestions
	}, [childquestions])
	const childquestionsOrdered = useSelector(
		(state) => selectQuestionsByServiceIdAndParentId(state, serviceId, questionId),
		shallowEqual
	)
	const childquestionsOrderedMemo = useMemo(() => {
		return childquestionsOrdered
	}, [childquestionsOrdered])
	const servicequestionmultichoice = useSelector(
		(state) => selectQuestionMultiChoicesByQuestionId(state, questionId),
		shallowEqual
	)
	const servicequestionmultichoiceMemo = useMemo(() => {
		return servicequestionmultichoice
	}, [servicequestionmultichoice])

	const sqInsert = (servicequestion, sid, sqid, sqorder) =>
		dispatch(serviceQuestionInsert(servicequestion, sid, sqid, sqorder))
	const sqUpdate = (json, id) => dispatch(serviceQuestionUpdate(json, id))
	const sqDelete = (id) => dispatch(serviceQuestionDelete(id))
	const sqmcInsert = (sqid) => dispatch(serviceQuestionMultiChoiceInsert(servicequestionmultichoiceMemo, sqid))
	const sqmcUpdate = (json, id) => dispatch(serviceQuestionMultiChoiceUpdate(json, id))
	const sqmcDelete = (id) => dispatch(serviceQuestionMultiChoiceDelete(id))

	let sqmcTemp = servicequestionmultichoiceMemo
		.filter((obj) => {
			return obj?.servicequestionid === servicequestionMemo?.servicequestionid
		})
		.sort((a, b) => (Number(a["sqmcorder"]) > Number(b["sqmcorder"]) ? 1 : -1))

	const childSqTemp = childquestionsMemo.filter((obj) => {
		return obj?.parent === servicequestionMemo?.servicequestionid
	})

	const copyQuestion = () => {
		const questions = servicequestionsMemo
		const findChilds = (question) => {
			return questions
				.filter((obj) => obj.parent === question.servicequestionid)
				.map((childQuestion) => {
					return {
						...childQuestion,
						childquestions: findChilds(childQuestion),
					}
				})
		}

		let newQuestion = {
			...servicequestionMemo,
			childquestions: findChilds(servicequestionMemo),
		}

		setClipboard(newQuestion)
	}

	return (
		<>
			<ListItem
				key={servicequestionMemo.servicequestionid}
				style={{ borderRadius: "10px", border: "1px solid", display: "flex", flexDirection: "column", width: "100%" }}>
				<Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%" }}>
					<Grid item sx={{ width: "33%" }}>
						<Typography variant="h6" color="primary">
							{servicequestionMemo.description + " " + servicequestionMemo.sqorder + ": "}
						</Typography>
					</Grid>
					<Grid
						item
						sx={{ alignItems: "center", display: "flex", cursor: "pointer", width: "33%", justifyContent: "center" }}
						onClick={() => setExpanded(!expanded)}>
						{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
					</Grid>
					<Grid item sx={{ alignItems: "center", display: "flex", width: "33%", justifyContent: "flex-end" }}>
						<Tooltip title="Liitä kysymys">
							<ContentPasteIcon
								color="primary"
								onClick={() =>
									pasteQuestion(
										questionId,
										childquestionsOrderedMemo.reduce((max, obj) => {
											return Math.max(max, obj.sqorder)
										}, 0) + 1
									)
								}
							/>
						</Tooltip>
						<Tooltip title="Kopioi kysymys">
							<ContentCopyIcon color="primary" onClick={() => copyQuestion()} />
						</Tooltip>
						{servicequestionMemo.questiontype !== "text" &&
						servicequestionMemo.questiontype !== "" &&
						servicequestionMemo.questiontype !== null &&
						servicequestionMemo.questiontype !== "date" ? (
							<Tooltip title="Lisää vastausvaihtoehto">
								<AddIcon color="primary" onClick={() => sqmcInsert(questionId)} />
							</Tooltip>
						) : (
							<Tooltip title="Lisää vastausvaihtoehto">
								<AddIcon color="secondary" />
							</Tooltip>
						)}
						<Tooltip title="Lisää alikysymys">
							<PostAddIcon
								color="primary"
								onClick={() => {
									console.log("childquestionsOrderedMemo", childquestionsOrderedMemo)
									setExpanded(true)
									sqInsert(
										null,
										servicequestionMemo.serviceid,
										servicequestionMemo.servicequestionid,
										childquestionsOrderedMemo.reduce((max, obj) => {
											return Math.max(max, obj.sqorder)
										}, 0) + 1
									)
								}}
							/>
						</Tooltip>
						<Tooltip title="Poista kysymys">
							<DeleteForeverIcon color="primary" onClick={() => sqDelete(servicequestionMemo.servicequestionid)} />
						</Tooltip>
					</Grid>
				</Grid>
				{expanded && (
					<Grid container direction="column" spacing={1} justifyContent="flex-start" alignItems="flex-start">
						<Grid item>
							<Grid container direction="row" spacing={1} justifyContent="flex-start" alignItems="flex-start">
								<Grid item>
									<TextField
										component={"span"}
										style={{ minWidth: 100 }}
										size="small"
										margin="normal"
										label="Kysymys"
										InputLabelProps={{ shrink: true }}
										variant="outlined"
										id={"sqdescription" + i}
										onBlur={(e) => sqUpdate({ description: e.target.value }, servicequestionMemo.servicequestionid)}
										defaultValue={servicequestionMemo.description === null ? "" : servicequestionMemo.description}
									/>
								</Grid>
								<Grid item>
									<TextField
										style={{ minWidth: 100 }}
										size="small"
										margin="normal"
										label="Pakollinen"
										select
										InputLabelProps={{ shrink: true }}
										variant="outlined"
										id={"required" + i}
										value={servicequestionMemo.required === null ? "" : servicequestionMemo.required}
										onChange={(e) => sqUpdate({ required: e.target.value }, servicequestionMemo.servicequestionid)}>
										{REQUIRED_TF.map((option) => (
											<MenuItem key={option.value} value={option.value}>
												{option.label}
											</MenuItem>
										))}
									</TextField>
								</Grid>
								<Grid item>
									<TextField
										style={{ minWidth: 100 }}
										size="small"
										margin="normal"
										label="Kysymystyyppi"
										select
										InputLabelProps={{ shrink: true }}
										variant="outlined"
										id={"questiontype" + i}
										value={servicequestionMemo.questiontype === null ? "" : servicequestionMemo.questiontype}
										onChange={(e) => sqUpdate({ questiontype: e.target.value }, servicequestionMemo.servicequestionid)}>
										{QUESTION_TYPE_TF.map((option) => (
											<MenuItem key={option.value} value={option.value}>
												{option.label}
											</MenuItem>
										))}
									</TextField>
								</Grid>
								<Grid item>
									<TextField
										style={{ minWidth: 100 }}
										size="small"
										margin="normal"
										label="Datan Tyyppi"
										select
										InputLabelProps={{ shrink: true }}
										variant="outlined"
										id={"datatype" + i}
										value={servicequestionMemo.datatype === null ? "" : servicequestionMemo.datatype}
										onChange={(e) => sqUpdate({ datatype: e.target.value }, servicequestionMemo.servicequestionid)}>
										{DATA_TYPE_TF.map((option) => (
											<MenuItem key={option.value} value={option.value}>
												{option.label}
											</MenuItem>
										))}
									</TextField>
								</Grid>
								<Grid item>
									<TextField
										style={{ minWidth: 100 }}
										size="small"
										margin="normal"
										label="Hinta per"
										type="number"
										InputLabelProps={{ shrink: true }}
										variant="outlined"
										id={"costperunit" + i}
										defaultValue={servicequestionMemo.costperunit === null ? 0 : servicequestionMemo.costperunit}
										onBlur={(e) => sqUpdate({ costperunit: e.target.value }, servicequestionMemo.servicequestionid)}
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid item>
							<Divider />
							<Typography variant="h6" color="primary">
								Vastausvaihtoehdot
							</Typography>
							{sqmcTemp.length > 0 &&
								sqmcTemp.map((sqmcObj, index) => {
									return (
										<Grid
											key={sqmcObj.servicequestionmultichoiceid}
											container
											direction="row"
											spacing={1}
											justifyContent="flex-start"
											alignItems="center">
											<Grid item>{sqmcObj.sqmcorder}.</Grid>
											<Grid item>
												<div>
													<TextField
														style={{ minWidth: 100 }}
														size="small"
														margin="normal"
														label="Vastaus"
														InputLabelProps={{ shrink: true }}
														variant="outlined"
														id={"sqmcdescription" + index + "-" + i}
														defaultValue={sqmcObj.description === null ? "" : sqmcObj.description}
														onBlur={(e) =>
															sqmcUpdate({ description: e.target.value }, sqmcObj.servicequestionmultichoiceid)
														}
													/>
												</div>
											</Grid>
											<Grid item>
												<div>
													<TextField
														style={{ minWidth: 100 }}
														size="small"
														margin="normal"
														label="Hinta per"
														type="number"
														InputLabelProps={{ shrink: true }}
														variant="outlined"
														id={"sqmccostperunit" + index + "-" + i}
														defaultValue={sqmcObj.costperunit === null ? 0 : sqmcObj.costperunit}
														onBlur={(e) =>
															sqmcUpdate({ costperunit: e.target.value }, sqmcObj.servicequestionmultichoiceid)
														}
													/>
												</div>
											</Grid>
											<Grid item>
												<Tooltip title="Poista vastausvaihtoehto">
													<DeleteForeverIcon
														color="primary"
														onClick={() => sqmcDelete(sqmcObj.servicequestionmultichoiceid)}
													/>
												</Tooltip>
											</Grid>
										</Grid>
									)
								})}
						</Grid>
						<Grid item sx={{ display: "inline-block", width: "100%" }}>
							<Divider />
							<Typography variant="h6" color="primary">
								Alakysymykset
							</Typography>
							<List sx={{ width: "100%" }}>
								{childSqTemp.length > 0 &&
									childSqTemp.map((cqObj) => {
										return (
											<RecursiveQuestionsAdmin
												key={cqObj.servicequestionid}
												parent={questionId}
												questionId={cqObj.servicequestionid}
												serviceId={serviceId}
												setClipboard={setClipboard}
												clipboard={clipboard}
												pasteQuestion={pasteQuestion}
											/>
										)
									})}
							</List>
						</Grid>
					</Grid>
				)}
			</ListItem>
		</>
	)
}

export default React.memo(RecursiveQuestionsAdmin)
